import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { Home } from "lucide-react";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-4">
      <h1 className="text-4xl font-bold">404</h1>
      <h2 className="text-xl">Page not found</h2>
      <p className="text-muted-foreground max-w-sm">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to={paths.root()}
        className="flex items-center gap-2 px-4 py-2 bg-[color:var(--color-primary)] text-white rounded hover:opacity-90 transition-opacity"
      >
        <Home className="w-4 h-4" />
        Back to Dashboard
      </Link>
    </div>
  );
}
